/**
 * Collection grid variant swatches: click updates product image with slide transition.
 */
(function () {
  'use strict';

  var SWATCH_SELECTOR = '.cmgp-swatch, .fcp-swatch, .vj-swatch, .prp-swatch';
  var MORE_SWATCH_SELECTOR =
    '.cmgp-swatch-more, .fcp-swatch-more, .vj-swatch-more, .prp-swatch-more';
  var SLIDE_MS = 450;
  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var PRESETS = {
    cmgp: {
      card: '.cmgp-product-card',
      primary: '.cmgp-image-primary',
      secondary: '.cmgp-image-secondary',
      link: '.cmgp-product-link',
      wrap: '.cmgp-variant-swatches',
      imageWrap: '.cmgp-product-image-wrapper',
      swatchClass: 'cmgp-swatch',
      activeClass: 'cmgp-swatch-active',
    },
    fcp: {
      card: '.fcp-product-card',
      primary: '.fcp-image-primary',
      secondary: '.fcp-image-secondary',
      link: '.fcp-product-link',
      wrap: '.fcp-variant-swatches',
      imageWrap: '.fcp-product-image-wrapper',
      swatchClass: 'fcp-swatch',
      activeClass: 'fcp-swatch-active',
    },
    vj: {
      card: '.vj-product-card',
      primary: '.vj-image-primary',
      secondary: '.vj-image-secondary',
      link: '.vj-product-link',
      wrap: '.vj-variant-swatches',
      imageWrap: '.vj-product-image-wrapper',
      swatchClass: 'vj-swatch',
      activeClass: 'vj-swatch-active',
    },
    prp: {
      card: '.prp-product-card',
      primary: '.prp-image-primary',
      secondary: '.prp-image-secondary',
      link: '.prp-product-link',
      wrap: '.prp-variant-swatches',
      imageWrap: '.prp-product-image-wrapper',
      swatchClass: 'prp-swatch',
      activeClass: 'prp-swatch-active',
    },
  };

  function getPreset(swatch) {
    if (swatch.classList.contains('cmgp-swatch')) return PRESETS.cmgp;
    if (swatch.classList.contains('fcp-swatch')) return PRESETS.fcp;
    if (swatch.classList.contains('vj-swatch')) return PRESETS.vj;
    if (swatch.classList.contains('prp-swatch')) return PRESETS.prp;
    return null;
  }

  function findCard(swatch, preset) {
    return swatch.closest(preset.card);
  }

  /** Inline gradients from cmgp-metal-swatch-style are authoritative — do not rewrite. */
  function fixSplitLineSwatches() {}

  function getImageWrapper(card, preset, primaryImage) {
    if (preset.imageWrap) {
      var wrap = card.querySelector(preset.imageWrap);
      if (wrap) return wrap;
    }
    return primaryImage ? primaryImage.parentElement : null;
  }

  function resolveTargetImage(swatch, card, preset) {
    var variantImageUrl = (swatch.dataset.variantImage || '').trim();
    if (variantImageUrl) return variantImageUrl;

    var swatchColor = (swatch.dataset.swatch || '').toLowerCase();
    if (preset.swatchClass !== 'prp-swatch') return '';

    var primaryImage = card.querySelector(preset.primary);
    var secondaryImage = card.querySelector(preset.secondary);

    if (
      swatchColor.indexOf('white') !== -1 ||
      swatchColor.indexOf('silver') !== -1 ||
      swatchColor.indexOf('platinum') !== -1 ||
      swatchColor.indexOf('rhodium') !== -1
    ) {
      return secondaryImage && secondaryImage.src ? secondaryImage.src : '';
    }

    if (swatchColor.indexOf('rose') !== -1 || swatchColor.indexOf('pink') !== -1) {
      var roseImg = card.querySelector('.prp-product-image[data-image-index="2"]');
      if (roseImg && roseImg.src) return roseImg.src;
      return secondaryImage && secondaryImage.src ? secondaryImage.src : '';
    }

    if (
      swatchColor.indexOf('yellow') !== -1 ||
      swatchColor === 'gold' ||
      swatchColor.indexOf('yellow-gold') !== -1
    ) {
      return card.dataset.originalImage || (primaryImage && primaryImage.src) || '';
    }

    return '';
  }

  function hideSecondary(card, preset, primaryImage) {
    var secondaryImage = preset.secondary ? card.querySelector(preset.secondary) : null;
    if (!secondaryImage) return;

    secondaryImage.style.opacity = '0';
    secondaryImage.style.pointerEvents = 'none';
    secondaryImage.style.zIndex = '0';
    if (primaryImage) {
      primaryImage.classList.add('has-secondary');
      primaryImage.style.zIndex = '3';
    }
  }

  function persistSelection(card, primaryImage, imageUrl) {
    card.dataset.selectedVariantImage = imageUrl;
    card.dataset.originalImage = imageUrl;
    card.dataset.originalSrcset = '';
    primaryImage.src = imageUrl;
    primaryImage.srcset = '';
    primaryImage.style.opacity = '1';
    primaryImage.style.display = 'block';
  }

  function applyImageInstant(card, preset, imageUrl) {
    if (!imageUrl || !card) return;

    var primaryImage = card.querySelector(preset.primary);
    if (!primaryImage) return;

    if (!card.dataset.originalImage) {
      card.dataset.originalImage = primaryImage.src;
      card.dataset.originalSrcset = primaryImage.srcset || '';
    }

    var img = new Image();
    img.onload = function () {
      persistSelection(card, primaryImage, imageUrl);
      hideSecondary(card, preset, primaryImage);
    };
    img.onerror = function () {};
    img.src = imageUrl;
  }

  function applyImageSlide(card, preset, imageUrl) {
    if (!imageUrl || !card) return;

    var primaryImage = card.querySelector(preset.primary);
    if (!primaryImage) return;

    var wrapper = getImageWrapper(card, preset, primaryImage);
    if (!wrapper) {
      applyImageInstant(card, preset, imageUrl);
      return;
    }

    var currentSrc = primaryImage.currentSrc || primaryImage.src;
    if (currentSrc === imageUrl) return;

    if (card.dataset.variantSliding === '1') return;

    if (!card.dataset.originalImage) {
      card.dataset.originalImage = primaryImage.src;
      card.dataset.originalSrcset = primaryImage.srcset || '';
    }

    if (REDUCED_MOTION) {
      applyImageInstant(card, preset, imageUrl);
      return;
    }

    card.dataset.variantSliding = '1';
    wrapper.classList.add('variant-image-slide-active');

    var preload = new Image();
    preload.onload = function () {
      var incoming = document.createElement('img');
      incoming.className = primaryImage.className + ' variant-slide-incoming';
      incoming.alt = primaryImage.alt || '';
      incoming.src = imageUrl;
      incoming.setAttribute('loading', 'eager');
      incoming.setAttribute('decoding', 'async');

      primaryImage.classList.add('variant-slide-outgoing');

      hideSecondary(card, preset, primaryImage);
      wrapper.appendChild(incoming);

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          wrapper.classList.add('variant-image-slide-go');
        });
      });

      var finished = false;
      function finish() {
        if (finished) return;
        finished = true;

        persistSelection(card, primaryImage, imageUrl);
        primaryImage.style.transform = '';
        primaryImage.style.transition = '';
        primaryImage.classList.remove('variant-slide-outgoing');

        if (incoming.parentNode) incoming.remove();

        wrapper.classList.remove('variant-image-slide-active', 'variant-image-slide-go');
        delete card.dataset.variantSliding;
      }

      incoming.addEventListener('transitionend', function (e) {
        if (e.propertyName === 'transform') finish();
      });
      setTimeout(finish, SLIDE_MS + 80);
    };

    preload.onerror = function () {
      delete card.dataset.variantSliding;
      wrapper.classList.remove('variant-image-slide-active', 'variant-image-slide-go');
    };

    preload.src = imageUrl;
  }

  function applyImage(card, preset, imageUrl, options) {
    var animate = options && options.animate;
    if (animate) {
      applyImageSlide(card, preset, imageUrl);
    } else {
      applyImageInstant(card, preset, imageUrl);
    }
  }

  function setActiveSwatch(swatch, preset) {
    var wrap = swatch.closest(preset.wrap);
    if (!wrap) return;

    wrap.querySelectorAll('.' + preset.swatchClass).forEach(function (el) {
      el.classList.remove(preset.activeClass);
    });

    swatch.classList.add(preset.activeClass);
  }

  function updateProductLink(card, preset, variantId, productUrl) {
    if (!card || !productUrl) return;

    var productLink = card.querySelector(preset.link);
    if (!productLink) return;

    try {
      var url = new URL(productUrl, window.location.origin);
      if (variantId) {
        url.searchParams.set('variant', variantId);
      }
      productLink.href = url.toString();
    } catch (err) {
      if (variantId) {
        productLink.href =
          productUrl + (productUrl.indexOf('?') === -1 ? '?' : '&') + 'variant=' + variantId;
      } else {
        productLink.href = productUrl;
      }
    }
  }

  function onSwatchClick(e) {
    var swatch = e.target.closest(SWATCH_SELECTOR);
    if (!swatch || swatch.matches(MORE_SWATCH_SELECTOR)) return;

    var preset = getPreset(swatch);
    if (!preset) return;

    var card = findCard(swatch, preset);
    if (!card) return;

    e.preventDefault();
    e.stopPropagation();

    var variantId = swatch.dataset.variantId;
    var productUrl = swatch.dataset.productUrl;
    var imageUrl = resolveTargetImage(swatch, card, preset);

    if (!imageUrl) return;

    applyImage(card, preset, imageUrl, { animate: true });
    setActiveSwatch(swatch, preset);
    updateProductLink(card, preset, variantId, productUrl);
  }

  document.addEventListener('click', onSwatchClick, true);

  function preloadSwatchImages(root) {
    var scope = root || document;
    scope.querySelectorAll(SWATCH_SELECTOR).forEach(function (swatch) {
      if (swatch.matches(MORE_SWATCH_SELECTOR)) return;
      var url = (swatch.dataset.variantImage || '').trim();
      if (url) {
        var img = new Image();
        img.src = url;
      }
    });
  }

  function initSwatches(root) {
    fixSplitLineSwatches(root);
    preloadSwatchImages(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSwatches();
    });
  } else {
    initSwatches();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initSwatches(e.target);
  });
})();
